<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">Speaker:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <cardSpeaker v-if="!loading" :data="speaker"/>
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'speakersEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import cardSpeaker from '@/components/card/cardSpeaker'

  export default {
    name: 'showSpeakersEdition',
    components:{cardSpeaker},

    data: () => ({
      loading:true,

      speaker:[],

      edition_id: null,
      speaker_id: null,
    }),

    methods:{
      async getSpeakerEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/speakers/'+this.speaker_id).then(response =>{
          this.speaker = response.data.data.speaker
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.speaker_id = this.$route.params.speaker_id
      this.getSpeakerEdition()
    },
  }
</script>
